// extracted by mini-css-extract-plugin
module.exports = {"header":"_372pG","wrapper":"_1lJZ7","headerWrapper":"_3NVjt","sectionInstall":"mR4Vf","programs":"_22Dsj","programsText":"XrzVC","installText":"_3ztm4","install":"_1l9JS"};